export const formatDateDDMMYYYY = (isoDate) => {
  if (!isoDate) return '';

  const date = new Date(isoDate);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};


export const isPastDate = (isoDate) => {
  if (!isoDate) return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0); // normalize

  const sermonDate = new Date(isoDate);
  sermonDate.setHours(0, 0, 0, 0);

  return sermonDate < today;
};
